import { useMemoizedFn } from 'ahooks';
import { message } from 'antd';
import useIM from 'hooks/business/im/useIM';
import { isTiKTok } from 'lib/utils/isTikTok';
import { useMemo } from 'react';
import { useTranslate } from '@tolgee/react';

export interface UseSendReturnCardProps {
  conversationId: Conversation.Conversation['conversationId'];
  channel: Conversation.Conversation['channel'];
  tradeStatus: Conversation.Trade.Vo['tradeStatus'];
  leChatStatus?: Conversation.Trade.LeChatLogisticsStatus;
  cancelType: Conversation.Trade.Vo['cancelType'];
  cancelReason: Conversation.Trade.Vo['cancelReason'];
  externalTradeId: string;
  externalSkuId: string;
}

export const useSendReturnCard = (props: UseSendReturnCardProps) => {
  const {
    conversationId,
    channel,
    tradeStatus,
    leChatStatus,
    cancelType,
    cancelReason,
    externalTradeId,
    externalSkuId,
  } = props;
  const { sendReturnRefundCard } = useIM();
  const { t } = useTranslate();

  const enable = useMemo(() => {
    return (
      isTiKTok(channel) &&
      tradeStatus === 'WAITING_SIGN' &&
      leChatStatus === 'LE_CHAT_SIGNED' &&
      !cancelType &&
      !cancelReason
    );
  }, [cancelReason, cancelType, channel, leChatStatus, tradeStatus]);

  const sendReturnCard = useMemoizedFn(() => {
    return sendReturnRefundCard(conversationId, {
      orderId: externalTradeId,
      skuId: externalSkuId,
    }).catch(() => {
      message.error(t('scene.chatWorkspace.orderTab.error.operationFailed'));
    });
  });

  return {
    enable,
    sendReturnCard,
  };
};
